
//图片请求地址
let imageUrl = "";
let urlMap = {
    "localhost":"http://192.168.100.100:8030",
    "127.0.0.1:8080":"https://eblockssingapore.com/api",
    "127.0.0.1:8081":"https://eblockssingapore.com/api",
    "eblockssingapore.com":"https://eblockssingapore.com/api",
}

//api请求地址
let baseUrl = urlMap[window.location.host];

export default {

    install:function (vue) {
        vue.prototype.$baseUrl = baseUrl;
        vue.prototype.$imageUrl = imageUrl;
    },
    baseUrl,
    imageUrl,
}



// WEBPACK FOOTER //
// ./src/config/index.js